// Leak-coverage configuration for the "Find Your Solution" quiz.
// ---------------------------------------------------------------------------
// Tiers drive which package (Good / Better / Best) covers each source:
//   P1 — highest-risk appliances: water heater, washing machine, HVAC
//   P2 — other appliances + toilets  (i.e. everything EXCEPT sinks)
//   P3 — sinks: kitchen, utility, and bathroom sinks
// Package coverage is cumulative:
//   Good   = P1                (the three highest-risk spots)
//   Better = P1 + P2           (everything selected minus sinks)
//   Best   = P1 + P2 + P3       (everything selected, sinks included)
// Sensor counts and prices are derived automatically; prices come from the
// live product data (Shopify), never from this file.
// ---------------------------------------------------------------------------

// Appliances / fixtures a home may have. The quiz collects a QUANTITY for each,
// since a home can have more than one (two fridges, a second washer, etc.).
export const leakSources = [
    { id: 'water-heater', label: 'Water heater',           icon: 'fas fa-temperature-high', tier: 'P1' },
    { id: 'washer',       label: 'Washing machine',        icon: 'fas fa-tshirt',           tier: 'P1' },
    { id: 'hvac',         label: 'HVAC / furnace',         icon: 'fas fa-wind',             tier: 'P1' },
    { id: 'dishwasher',   label: 'Dishwasher',             icon: 'fas fa-utensils',         tier: 'P2' },
    { id: 'fridge',       label: 'Fridge w/ ice or water', icon: 'fas fa-snowflake',        tier: 'P2' },
    { id: 'basement',     label: 'Basement / sump pump',   icon: 'fas fa-water',            tier: 'P2' },
    { id: 'kitchen',      label: 'Kitchen sink',           icon: 'fas fa-sink',             tier: 'P3', sink: true },
    { id: 'utility',      label: 'Utility / laundry sink',  icon: 'fas fa-faucet',          tier: 'P3', sink: true },
];

// Each bathroom seeds one sink (P3) and one toilet (P2) sensor by default.
// The customer can adjust these quantities in the quiz.
export const bathroomFixtures = [
    { id: 'bath-sink', label: 'Bathroom sink', icon: 'fas fa-sink',   tier: 'P3', sink: true },
    { id: 'toilet',    label: 'Toilet',        icon: 'fas fa-toilet', tier: 'P2' },
];

// Which priority tiers each package covers (cumulative — see header).
export const packages = [
    { key: 'good',   label: 'Good',   tiers: ['P1'],             note: 'Your highest-risk spots — water heater, washing machine, and HVAC.' },
    { key: 'better', label: 'Better', tiers: ['P1', 'P2'],       note: 'Every appliance and toilet — the most common sources of leaks and floods.', recommended: true },
    { key: 'best',   label: 'Best',   tiers: ['P1', 'P2', 'P3'], note: 'Complete coverage — every source we found, sinks included.' },
];

// The Base Network is the base of every package.
export const starterPack = { handle: 'starter-pack', sensorsIncluded: 3, sensorHandle: 'water-sensor' };
